import { isEqual } from 'lodash-es';
import { enumIdentifierQualifier } from '@data-layer/enums/common';
import { EntityModel } from '@data-layer/models/entities';
import { CompanyModel } from '@data-layer/models/companies';

/**
 * True when the filing's importer is identified by a CBP Assigned Number (ANI).
 *
 * Per CBP such an importer must file a FORMAL entry at any goods value (#13283),
 * so the client-side "goods value too small for Formal" threshold must not apply
 * to it (#13284). Kept as a single predicate because the threshold rule is
 * duplicated across ES form validators, the desktop banners and the filing-level
 * validation service.
 */
export function isCbpAssignedNumberImporter(importer: EntityModel): boolean {
  return !!importer && importer.entityIdentifierQualifier === enumIdentifierQualifier.ANI;
}

/**
 * True when the ISF importer entity is a copy of the company (IOR) profile:
 * identifier, name and address all match.
 *
 * #13536: the name is part of the check (as the Entry Summary checks already do) —
 * an importer with the company's EIN and address but another name must not be
 * reported as "Same as IOR profile", or a wrong name stays hidden (ISF6816713).
 */
export function isImporterFromCompany(importer: EntityModel, company: CompanyModel): boolean {
  if (!importer || !company) {
    return false;
  }

  return (
    importer.entityIdentifierQualifier === company.identifierQualifier &&
    importer.entityIdentifier === company.identifier &&
    importer.name === company.businessName &&
    isEqual(importer.address, company.address)
  );
}
